import { ChevronRight } from 'lucide-react';
import { Fragment } from 'react';
import { Link } from 'react-router-dom';

export type AdminCrumb = { label: string; to?: string };

export function AdminBreadcrumbs({ items }: { items: AdminCrumb[] }) {
  return (
    <nav aria-label="Breadcrumb" className="mb-4">
      <ol className="flex flex-wrap items-center gap-1 text-xs text-muted-foreground">
        {items.map((item, index) => (
          <Fragment key={`${item.label}:${index}`}>
            {index > 0 ? <ChevronRight className="h-3 w-3 shrink-0 opacity-60" aria-hidden="true" /> : null}
            <li className="min-w-0">
              {item.to ? (
                <Link to={item.to} className="block max-w-[16rem] truncate hover:text-foreground">
                  {item.label}
                </Link>
              ) : (
                <span className="block max-w-[20rem] truncate text-foreground" aria-current="page">
                  {item.label}
                </span>
              )}
            </li>
          </Fragment>
        ))}
      </ol>
    </nav>
  );
}
